/* tslint:disable */
/* eslint-disable */
/**
 * Property Search API
 * Search properties and get aggregated info about areas.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MappingDto } from './MappingDto';
import {
    MappingDtoFromJSON,
    MappingDtoFromJSONTyped,
    MappingDtoToJSON,
    MappingDtoToJSONTyped,
} from './MappingDto';

/**
 * 
 * @export
 * @interface PropertySubTypeDto
 */
export interface PropertySubTypeDto {
    /**
     * 
     * @type {string}
     * @memberof PropertySubTypeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PropertySubTypeDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PropertySubTypeDto
     */
    nameId: string;
    /**
     * 
     * @type {Array<MappingDto>}
     * @memberof PropertySubTypeDto
     */
    mappings: Array<MappingDto>;
}

/**
 * Check if a given object implements the PropertySubTypeDto interface.
 */
export function instanceOfPropertySubTypeDto(value: object): value is PropertySubTypeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nameId' in value) || value['nameId'] === undefined) return false;
    if (!('mappings' in value) || value['mappings'] === undefined) return false;
    return true;
}

export function PropertySubTypeDtoFromJSON(json: any): PropertySubTypeDto {
    return PropertySubTypeDtoFromJSONTyped(json, false);
}

export function PropertySubTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertySubTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'nameId': json['nameId'],
        'mappings': ((json['mappings'] as Array<any>).map(MappingDtoFromJSON)),
    };
}

export function PropertySubTypeDtoToJSON(json: any): PropertySubTypeDto {
    return PropertySubTypeDtoToJSONTyped(json, false);
}

export function PropertySubTypeDtoToJSONTyped(value?: PropertySubTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameId': value['nameId'],
        'mappings': ((value['mappings'] as Array<any>).map(MappingDtoToJSON)),
    };
}

